<script setup>
import LayoutView from '@/views/layout/index.vue'
import GlobalErrorListener from '@/components/GlobalErrorListener.vue'
import { isRouterReady } from './main'
</script>

<template>
  <LayoutView v-if="isRouterReady"/>
  <GlobalErrorListener />
</template>

<style scoped>

</style>
